<template>
  <div class="page-content prose">
    <div class="container">
      <h1>Op zoek naar een airco?</h1>
      <p>
        Is het in de zomer veel te warm bij u thuis? Kan door een gebrek aan
        doorluchtmogelijkheden de temperatuur maar niet dalen? Wordt er bij u op
        kantoor ook constant aan alle knoppen gedraaid omdat het telkens of te
        warm en vervolgens weer te koud is? Een degelijk airconditioningsysteem
        is dan de ideale oplossing voor u. Gespecialiseerde bedrijven helpen u
        met het kiezen van het juiste systeem en het installeren en
        optimaliseren ervan. En als het even niet meer werkt hoeft u niet direct
        met de handen in het haar te zitten – zij komen dit probleem direct
        verhelpen. Lees hier wat u moet weten voordat u een
        airconditioningsysteem aanschaft.
      </p>

      <h2>Voordelen van een airco</h2>
      <p>
        De voordelen van een airco zijn eindeloos. Een airconditioningsysteem is
        perfect af te stellen op persoonlijke behoeften. Te warm of te koud
        behoort vanaf de komst van een airco definitief tot het verleden.
        Tegenwoordig zijn dergelijke systemen ook nog eens zo geavanceerd dat ze
        direct een luchtzuiverende werking hebben. Daarnaast is het bij de
        airco’s van tegenwoordig zo dat ze ofwel amper te zien zijn of qua
        design naadloos aansluiten op een moderne en strakke ruimte. Een
        aircospecialist kan u wegwijs maken in alle mogelijkheden op het gebied
        van temperatuurregeling.
      </p>

      <h2>Particulier</h2>
      <p>
        Op zoek naar een duurzame en energiezuinige manier van klimaatregeling
        voor uw huis? Het aanschaffen van een airco dekt beide behoeften. Een
        aangenaam binnenklimaat is een must voor een optimaal comfortabele
        woning. Daarnaast zijn de kosten voor een aircosysteem uiteindelijk
        terug te verdienen door de energiezuinige eigenschap van dit geavanceerd
        stukje techniek. Bent u bang dat een airco lawaai maakt? Daar hoeft u
        zich geen zorgen over te maken – hedendaagse systemen zijn zo goed als
        geruisloos.
      </p>

      <h2>Zakelijk</h2>
      <p>
        Kantoorruimtes zijn vaak lastig op een ideale temperatuur te krijgen. De
        temperatuur regelen voor zo’n grote ruimte via de gewone verwarming
        zorgt er vaak voor dat het naast de radiator bloedheet is, terwijl de
        vingers van de medewerkers aan de andere kant van de ruimte er zo
        ongeveer afvriezen. Een professioneel aircosysteem biedt de uitkomst:
        hierdoor verkrijg je een stabiele en aangename temperatuur voor al uw
        werknemers.
      </p>

      <h2>Vraag nu meerdere offertes aan!</h2>
      <p>
        Denkt u ook dat een airco een perfecte toevoeging zal zijn in uw huis of
        binnen uw bedrijf? Dan hebben wij goed nieuws voor u: in slechts enkele
        minuten kunt u gratis meerdere offertes aanvragen voor
        airconditioningsystemen bij aanbieders uit uw omgeving. Die ideale
        kamertemperatuur is nog nooit zo dichtbij geweest, dus vraag de op u
        persoonlijk afgestemde voorstellen direct op!
      </p>
    </div>
  </div>
</template>

<script>
import AbstractPage from 'chimera/all/components/page/AbstractPage'

export default {
  extends: AbstractPage,

  layout: 'content',

  /**
   * @returns {object}
   */
  data() {
    return {
      title: 'Op zoek naar een airco?',
      description:
        'Vul je postcode in en vergelijk geheel gratis 6 offertes van vakkundige Bedrijven uit jouw regio ✓ Dé beste prijs voor jouw Reparatie ✓ Bespaar tot 40%',
    }
  },
}
</script>
